<template>
  <div
    :class="['zg-tips', {
      'zg-tips--section': section,
      'zg-tips--inline-label': inlineLabel,
      [`zg-tips--${size}`]: size
    }]"
  >
    <label v-if="label">
      {{ label }}
    </label>

    <ul class="tips">
      <li
        v-for="(item, index) in items"
        :key="index"
      >
        <a :href="item.href">
          <zg-chip
            :size="size"
            :icons="{
              left: item.icons && item.icons.left,
              leftRotation: item.icons && item.icons.leftRotation,
              right: item.icons && item.icons.right,
              rightRotation: item.icons && item.icons.rightRotation,
            }"
            :selected="item.selected || (active && item.key && active === item.key) || (active && item.title && active === item.title)"
            :text="item.text"
            @click.native="onClick(item.key, item.title)"
          />
        </a>
      </li>

      <li
        v-if="numberOfHiddenTips"
        class="hidden-tips"
        @click="$emit('showAll')"
      >
        +{{ numberOfHiddenTips }}

        <zg-icon
          icon="chevron"
          size="xsmall"
        />
      </li>
    </ul>
  </div>
</template>

<script>
  import ZgChip from '../ZgChip/ZgChip'
  import ZgIcon from '../ZgIcon/ZgIcon.vue'

  export default {
    name: 'ZgTips',
    components: {
      ZgChip,
      ZgIcon
    },
    props: {
      size: {
        type: String,
        required: false,
        default: 'large',
        validator: value => ['small', 'medium', 'large'].includes(value)
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      items: {
        type: Array,
        required: true
      },
      numberOfHiddenTips: {
        type: Number,
        required: false,
        default: 0
      },
      section: {
        type: Boolean,
        required: false,
        default: false
      },
      inlineLabel: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: () => ({
      active: null
    }),
    methods: {
      onClick (key, title) {
        this.active = key ?? title
        this.$emit('click', key ?? title)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-tips {
    display: flex;
    flex-direction: column;

    label {
      @include type-title-s;

      display: block;
      margin: 0 0 rhythm(xsmall);
    }

    &--small {
      .icons {
        column-gap: rem(3.5px);
      }
    }

    &--medium {
      .icons {
        column-gap: rem(6px);
      }
    }

    &--large {
      .icons {
        column-gap: rem(8.25px);
      }
    }

    &--section {
      .tips {
        text-align: center;
      }

      .tip {
        margin-right: rhythm(small);
        margin-bottom: rhythm(small);
      }

      .hidden-tips {
        margin-bottom: rhythm(small);
      }
    }

    &--inline-label {
      flex-direction: column;
      gap: rem(16px);

      @include mq(medium) {
        flex-direction: row;
        align-items: center;
      }

      label {
        margin: 0;
      }
    }
  }

  .tips {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    list-style: none;
    gap: rem(8px);
    padding: 0;
    margin: 0;

    li {
      padding: 0;
      margin: 0;
    }

    a {
      border: none;
    }
  }

  .hidden-tips {
    @include type-title-xxs;

    display: flex;
    align-items: center;
    margin: 0;
    cursor: pointer;
  }
</style>
